<template>
  <div>
    <md-button class="md-primary md-raised">Add Client</md-button>
  </div>
</template>

<script>
export default {
  name: "AddClientDialogAction",
  beforeDestroy: function () {
    //todo
    // eventBus.$off("add-client-form-validation");
  },
};
</script>

<style>
</style>